import React from 'react';
import PropTypes from 'prop-types';
import { Stepper as MuiStepper, Step as MuiStep, StepLabel as MuiStepLabel } from '@mui/material';

// Component scope - Constants and static data
const STEPPER_ORIENTATIONS = ['horizontal', 'vertical'];
const STEPPER_ALIGNMENTS = ['left', 'right'];

/**
 * App Stepper Component - Wrapper for MUI Stepper
 * @component
 * @param {Object} props - Component props
 * @returns {React.ReactElement} AppStepperComponent
 */
const AppStepperComponent = ({ 
  activeStep = 0,
  orientation = 'vertical',
  alternativeLabel = false,
  connector,
  nonLinear = false,
  steps = [],
  sx = {},
  ...props 
}) => {
  // Return/rendering
  return (
    <MuiStepper
      activeStep={activeStep}
      orientation={orientation}
      alternativeLabel={alternativeLabel}
      connector={connector}
      nonLinear={nonLinear}
      sx={{
        '& .MuiStepLabel-root': {
          '& .MuiStepLabel-label': {
            color: 'white',
            fontSize: '14px',
            fontWeight: 500
          },
          '& .MuiStepLabel-iconContainer': {
            '& .MuiSvgIcon-root': {
              color: '#1455FF',
              fontSize: '20px'
            }
          }
        },
        '& .MuiStepConnector-root': {
          '& .MuiStepConnector-line': {
            
            borderColor: 'red',
            borderWidth: '1px'
          }
        },
        ...sx
      }}
      {...props}
    >
      {steps.map((step, index) => (
        <MuiStep key={index}>
          <MuiStepLabel
            icon={step.icon}
            optional={step.optional}
            sx={{
              '& .MuiStepLabel-label': {
                color: index <= activeStep ? 'white' : '#6B7280',
                fontSize: '14px',
                fontWeight: index <= activeStep ? 600 : 400
              }
            }}
          >
            {step.label}
          </MuiStepLabel>
        </MuiStep>
      ))}
    </MuiStepper>
  );
};

AppStepperComponent.propTypes = {
  activeStep: PropTypes.number,
  orientation: PropTypes.oneOf(STEPPER_ORIENTATIONS),
  alternativeLabel: PropTypes.bool,
  connector: PropTypes.element,
  nonLinear: PropTypes.bool,
  steps: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    icon: PropTypes.node,
    optional: PropTypes.node
  })),
  sx: PropTypes.object
};

export default AppStepperComponent;
